/*
 * Pizzamateur — upsell du tiroir panier.
 * Deux blocs distincts, pour ne pas faire un pavé :
 *   1. .pm-goal  — barre de progression vers -10 %, EN BAS du tiroir,
 *                  sous le récapitulatif et le bouton Payer (05/10/2026)
 *   2. .pm-up    — carrousel « Complétez votre commande », avant le récapitulatif
 *
 * Le carrousel montre UNE carte à la fois et passe à la suivante toutes les
 * 3 s (voir animerRail). Si un code promo est déjà saisi, l'encart « recevez
 * votre code » est masqué (voir codeSaisi).
 *
 * Produits : API native Shopify /recommendations avec intent=related
 * ('complementary' exige des associations saisies à la main dans l'admin,
 * absentes ici — vérifié le 21/09/2026 : 0 résultat).
 * Rendu par la section pm-upsell-products, en Liquid, pour disposer des
 * métachamps d'avis et des prix formatés que l'API JSON ne donne pas.
 *
 * Le tiroir n'expose pas toujours les mêmes blocs selon l'état du panier :
 * on insère au meilleur endroit disponible, jamais en échouant.
 */
(function () {
  'use strict';

  var SEUIL_CENTIMES = 3500; // -10 % dès 35 €
  var MAX_PRODUITS = 6;
  var SECTION = 'pm-upsell-products';
  var DUREE = 3000; // ms d'affichage de chaque produit avant de passer au suivant
  var REPRISE = 5000; // ms d'attente après un geste du visiteur avant de relancer

  function euros(c) {
    return (c / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Retour d'inscription depuis le tiroir (pm_news=panier) : on rouvre le
   * panier avec la confirmation DEDANS, au lieu de laisser la page nue.
   * pm_goal_done retient l'inscription pour ne plus redemander l'e-mail. */
  var SUCCES_PANIER = /[?&]pm_news=panier/.test(window.location.search);
  var DEJA_INSCRIT = false;
  try { DEJA_INSCRIT = localStorage.getItem('pm_goal_done') === 'true'; } catch (e) {}
  if (SUCCES_PANIER) {
    DEJA_INSCRIT = true;
    try {
      localStorage.setItem('pm_goal_done', 'true');
      localStorage.setItem('pizzamateur_popup_seen', 'true');
    } catch (e) {}
    try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
  }

  function poserFlagLivraison(dlg) {
    var ctas = dlg.querySelector('.cart__ctas');
    if (!ctas || dlg.querySelector('.pm-livraison-flag')) return;
    var flag = document.createElement('div');
    flag.className = 'pm-livraison-flag';
    flag.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="1" y="3" width="15" height="13"></rect>' +
      '<polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>' +
      '<circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>' +
      '<span>Livraison offerte</span>';
    ctas.parentNode.insertBefore(flag, ctas);
  }
  function placerFormulaire(bloc) {
    var source = document.getElementById('pm-goal-real-form');
    var slot = bloc.querySelector('.pm-goal__form-slot');
    if (!source || !slot) return;
    // clone : l'original reste cache dans theme.liquid, un re-rendu du tiroir
    // ne peut donc jamais le detruire.
    var f = source.cloneNode(true);
    f.id = 'pm-goal-form-actif';
    var retour = f.querySelector('input[name="return_to"]');
    if (retour) retour.value = window.location.pathname + '?pm_news=panier';
    slot.appendChild(f);
  }

  function dialogTiroir() {
    return document.querySelector('cart-drawer-component dialog');
  }

  /* ---------- 1. barre de progression ---------- */
  // Code déjà saisi dans le panier ? (BIENVENUE10 ou autre)
  //  - applicable     -> l'encart ne sert plus à rien : on le masque
  //  - non applicable -> (sous 35 €) on garde la barre, sans promettre d'e-mail
  function codeSaisi(cart) {
    var codes = (cart && cart.discount_codes) || [];
    var actif = codes.filter(function (c) { return c.applicable; })[0];
    if (actif || ((cart && cart.cart_level_discount_applications) || []).length) {
      return { etat: 'actif', code: actif ? actif.code : '' };
    }
    if (codes.length) return { etat: 'attente', code: codes[0].code };
    return null;
  }

  function blocObjectif(total, saisi) {
    var reste = SEUIL_CENTIMES - total;
    var atteint = reste <= 0;
    var pourcent = Math.max(4, Math.min(100, Math.round((total / SEUIL_CENTIMES) * 100)));

    var el = document.createElement('div');
    el.className = 'pm-goal' + (atteint ? ' pm-goal--done' : '');

    // L'élément reste présent (masqué) : l'observateur plus bas ré-injecte
    // les blocs dès que .pm-goal manque — sans lui, boucle infinie.
    if (saisi && saisi.etat === 'actif') {
      el.className += ' pm-goal--masque';
      el.hidden = true;
      return el;
    }
    if (saisi && saisi.etat === 'attente') {
      el.innerHTML =
        '<p class="pm-goal__text">Plus que <strong>' + euros(Math.max(reste, 0)) +
        '</strong> pour activer votre code <strong>' + String(saisi.code).replace(/[<>&"]/g, '') + '</strong></p>' +
        '<div class="pm-goal__bar" role="presentation"><span style="width:' + pourcent + '%"></span></div>';
      return el;
    }

    if (SUCCES_PANIER || DEJA_INSCRIT) {
      el.innerHTML =
        '<p class="pm-goal__text">' +
        (SUCCES_PANIER
          ? '<strong>C’est noté !</strong> Votre code <strong>&minus;10 %</strong> arrive par e-mail.'
          : 'Votre code <strong>&minus;10 %</strong> vous attend dans votre boîte mail — saisissez-le au paiement.') +
        '</p>' +
        '<div class="pm-goal__bar" role="presentation"><span style="width:' + pourcent + '%"></span></div>';
      return el;
    }

    el.innerHTML =
      '<p class="pm-goal__text">' +
      (atteint
        ? '<strong>35 €</strong> atteints : recevez votre code <strong>&minus;10 %</strong> par e-mail'
        : 'Plus que <strong>' + euros(reste) + '</strong> pour profiter de <strong>&minus;10 %</strong>') +
      '</p>' +
      '<div class="pm-goal__bar" role="presentation"><span style="width:' + pourcent + '%"></span></div>' +
      '<div class="pm-goal__form-slot"></div>' +
      '<p class="pm-goal__sub">Code envoyé par e-mail · désinscription en un clic</p>';
    return el;
  }

  /* ---------- 2. produits suggérés ---------- */
  function chargerRecommandations(cart) {
    var items = cart.items || [];
    if (!items.length) return Promise.resolve(null);
    var ref = items[items.length - 1].product_id; // le dernier ajouté porte l'intention
    var url =
      '/recommendations/products?section_id=' + SECTION +
      '&product_id=' + ref +
      '&limit=10&intent=related';
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .catch(function () { return null; });
  }

  function construireRail(html, cart) {
    var hote = document.createElement('div');
    hote.innerHTML = html;
    var rail = hote.querySelector('[data-pm-upsell-rail]');
    if (!rail) return null;

    var gardees = 0;
    Array.prototype.slice.call(rail.querySelectorAll('.pm-up__card')).forEach(function (carte) {
      var bouton = carte.querySelector('[data-pm-upsell-add]');
      var id = bouton ? parseInt(bouton.getAttribute('data-pm-upsell-add'), 10) : 0;
      var dejaLa = (cart.items || []).some(function (i) { return i.variant_id === id; });
      if (dejaLa || gardees >= MAX_PRODUITS) { carte.remove(); return; }
      gardees++;
    });
    return gardees > 0 ? rail : null;
  }

  /* ---------- carrousel : une carte à la fois ----------
   * Chaque produit reste affiché DUREE ms, puis glisse vers le suivant.
   * Le rail est un défilement horizontal « aimanté » (scroll-snap) : le
   * visiteur peut aussi faire glisser au doigt. Tout geste met en pause,
   * reprise REPRISE ms plus tard. Rien ne bouge si le visiteur a demandé
   * moins d'animations, ni quand le tiroir est fermé.
   * Boucle : une copie de la 1re carte est ajoutée à la fin ; arrivé
   * dessus, on revient à la vraie 1re carte sans animation (raccord invisible). */
  var minuterie = null;

  function animerRail(rail, bloc) {
    if (minuterie) { clearInterval(minuterie); minuterie = null; }

    var cartes = Array.prototype.slice.call(rail.children);
    var n = cartes.length;
    if (n < 2) return;

    // points de navigation
    var points = document.createElement('div');
    points.className = 'pm-up__dots';
    cartes.forEach(function (c, i) {
      var p = document.createElement('button');
      p.type = 'button';
      p.className = 'pm-up__dot' + (i === 0 ? ' is-active' : '');
      p.setAttribute('aria-label', 'Produit ' + (i + 1) + ' sur ' + n);
      p.addEventListener('click', function () { pause(); aller(i, true); reprendre(REPRISE); });
      points.appendChild(p);
    });
    bloc.appendChild(points);

    var copie = cartes[0].cloneNode(true);
    copie.setAttribute('aria-hidden', 'true');
    copie.classList.add('pm-up__card--copie');
    Array.prototype.slice.call(copie.querySelectorAll('a, button')).forEach(function (e) {
      e.setAttribute('tabindex', '-1');
    });
    rail.appendChild(copie);

    function pas() {
      return rail.children[1].offsetLeft - rail.children[0].offsetLeft;
    }
    function indexCourant() {
      var p = pas();
      return p > 0 ? Math.round(rail.scrollLeft / p) : 0;
    }
    function marquer(i) {
      var actif = i % n;
      Array.prototype.slice.call(points.children).forEach(function (p, k) {
        p.classList.toggle('is-active', k === actif);
      });
    }
    function aller(i, doux) {
      rail.scrollTo({ left: i * pas(), behavior: doux ? 'smooth' : 'auto' });
    }

    var raccord = null;
    rail.addEventListener('scroll', function () {
      marquer(indexCourant());
      if (raccord) clearTimeout(raccord);
      raccord = setTimeout(function () {
        if (indexCourant() >= n) aller(0, false); // sur la copie : retour discret
      }, 160);
    }, { passive: true });

    var enPause = false;
    var reprise = null;
    function pause() {
      enPause = true;
      if (reprise) { clearTimeout(reprise); reprise = null; }
    }
    function reprendre(delai) {
      if (reprise) clearTimeout(reprise);
      reprise = setTimeout(function () { enPause = false; }, delai);
    }
    rail.addEventListener('pointerenter', pause);
    rail.addEventListener('pointerleave', function () { reprendre(1500); });
    rail.addEventListener('focusin', pause);
    rail.addEventListener('focusout', function () { reprendre(1500); });
    rail.addEventListener('touchstart', pause, { passive: true });
    rail.addEventListener('touchend', function () { reprendre(REPRISE); }, { passive: true });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    minuterie = setInterval(function () {
      if (!rail.isConnected) { clearInterval(minuterie); minuterie = null; return; }
      var dlg = dialogTiroir();
      if (enPause || !dlg || !dlg.open || document.hidden) return;
      aller(Math.min(indexCourant() + 1, n), true);
    }, DUREE);
  }

  /* ---------- ajout en un clic ---------- */
  function brancherAjouts(bloc) {
    bloc.addEventListener('click', function (e) {
      var bouton = e.target.closest('[data-pm-upsell-add]');
      if (!bouton || bouton.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      var id = Number(bouton.getAttribute('data-pm-upsell-add'));
      var libelle = bouton.textContent;
      bouton.disabled = true;
      bouton.textContent = 'Ajout…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('refus');
          bouton.textContent = 'Ajouté';
          return rafraichirTiroir();
        })
        .catch(function () {
          bouton.disabled = false;
          bouton.textContent = libelle;
        });
    });
  }

  /* ---------- rafraîchir le tiroir après un ajout ---------- */
  function rafraichirTiroir() {
    var dlg = dialogTiroir();
    if (!dlg) return;
    var section = dlg.closest('[id^="shopify-section"]');
    var id = section ? section.id.replace('shopify-section-', '') : null;
    if (!id) return injecter(true);

    return fetch('/?section_id=' + id)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html) {
          var frais = document.createElement('div');
          frais.innerHTML = html;
          var nouveau = frais.querySelector('cart-drawer-component dialog .cart-drawer__inner');
          var actuel = dlg.querySelector('.cart-drawer__inner');
          if (nouveau && actuel) actuel.replaceWith(nouveau);
        }
        return injecter(true);
      })
      .catch(function () { return injecter(true); });
  }

  /* ---------- injection ---------- */
  var enCours = false;

  function injecter(force) {
    var dlg = dialogTiroir();
    if (!dlg || enCours) return;

    var contenu = dlg.querySelector('.cart-drawer__content');
    var items = dlg.querySelector('.cart-drawer__items');
    var resume = dlg.querySelector('.cart-drawer__summary');
    if (!contenu && !items) return;

    var dejaLa = dlg.querySelector('.pm-up') || dlg.querySelector('.pm-goal');
    if (dejaLa && !force) return;
    if (dejaLa) {
      var vieux = dlg.querySelector('.pm-goal');
      if (vieux) vieux.remove();
      var vieuxRail = dlg.querySelector('.pm-up');
      if (vieuxRail) vieuxRail.remove();
    }

    enCours = true;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;

        // 1. la barre d'objectif, tout en bas : sous le récapitulatif et le
        //    bouton Payer. Le tiroir s'ouvre sur les articles et le paiement.
        var objectif = blocObjectif(cart.total_price, codeSaisi(cart));
        if (resume && resume.parentNode) resume.parentNode.insertBefore(objectif, resume.nextSibling);
        else if (items && items.parentNode) items.parentNode.insertBefore(objectif, items.nextSibling);
        else contenu.appendChild(objectif);
        placerFormulaire(objectif);
        poserFlagLivraison(dlg);
        setTimeout(function () { poserFlagLivraison(dlg); }, 900);
        setTimeout(function () { poserFlagLivraison(dlg); }, 2600);

        return chargerRecommandations(cart).then(function (html) {
          if (!html) return;
          var rail = construireRail(html, cart);
          if (!rail) return;

          var bloc = document.createElement('div');
          bloc.className = 'pm-up';
          var titre = document.createElement('p');
          titre.className = 'pm-up__head';
          titre.textContent = 'Complétez votre commande';
          bloc.appendChild(titre);
          bloc.appendChild(rail);
          brancherAjouts(bloc);

          // 2. le carrousel, juste avant le récapitulatif.
          if (resume && resume.parentNode) resume.parentNode.insertBefore(bloc, resume);
          else if (items && items.parentNode) items.parentNode.insertBefore(bloc, items.nextSibling);
          else contenu.appendChild(bloc);

          // signale au CSS que le tiroir héberge nos blocs : sans cela,
          // le conteneur flex écrase la liste des articles à 0 de hauteur.
          if (contenu) contenu.classList.add('pm-up-host');
          animerRail(rail, bloc);
        });
      })
      .catch(function () { /* silencieux */ })
      .then(function () { enCours = false; });
  }

  /* ---------- déclencheurs ----------
   * Le dialog peut être rendu tard, et remplacé par le thème après un ajout.
   * On observe donc tout le document, filtré sur l'attribut « open ». */
  function surveiller() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var cible = mutations[i].target;
        if (
          cible &&
          cible.tagName === 'DIALOG' &&
          cible.hasAttribute('open') &&
          cible.closest('cart-drawer-component')
        ) {
          injecter(false);
          return;
        }
      }
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true
    });

    var dlg = dialogTiroir();
    if (dlg && dlg.open) injecter(false);

    // Retour d'inscription : on rouvre le tiroir dès que le composant existe.
    if (SUCCES_PANIER && window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-component').then(function () {
        setTimeout(function () {
          var comp = document.querySelector('cart-drawer-component');
          if (comp && typeof comp.open === 'function') comp.open();
        }, 300);
      });
    }

    // Le theme re-rend parfois l'interieur du tiroir apres l'ouverture,
    // ce qui efface nos blocs : on les re-pose des qu'ils manquent.
    var attente = null;
    new MutationObserver(function () {
      if (attente) return;
      attente = setTimeout(function () {
        attente = null;
        var d = dialogTiroir();
        if (d && d.open && !d.querySelector('.pm-goal')) injecter(false);
      }, 350);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', surveiller);
  } else {
    surveiller();
  }
})();
